let language = {
    "terms:AcceptanceOfTerms": "Acceptance of Terms",
    "terms:Content": "Content",
    "terms:StoragePolicy": "Storage Policy",
    "terms:UseOfTheWebsite": "Use of the Website",
    "terms:IntellectualProperty": "Intellectual Property",
    "temrs:PrivacyPolicy": "Privacy Policy",
    "terms:WebAddresses": "Web Addresses (URLs)",
    "terms:LimitedWarranty": "Limited Warranty",
    "terms:LimitationOfLiability": "Limitation of Liability",
    "terms:Title": "Title",
    "terms:ShippingTime": "Shipping Time",
    "terms:Restrictions": "Shipping Restrictions",
    "terms:Interpretation": "Interpretation",
    "terms:Arbitration": "Arbitration",
    "terms:Severability": "Severability",
    "terms:General": "General",
    "terms:OurAddress": "Our Address"
};

export { language }